import XhrRequestHandler from '../../lib/XhrRequestHandler';

export interface AgrupadorCorporacionLiquidadoraResponse {
  statusCode:   number;
  statusMsg:    string;
  statusDetail: string;
  debugInfo:    null;
  httpCode:     null;
  attributes:   null;
  data:         AgrupadorCorporacionLiquidadora[];
  segment:      null;
}

export interface AgrupadorCorporacionLiquidadoraResponseById {
  statusCode:   number;
  statusMsg:    string;
  statusDetail: string;
  debugInfo:    null;
  httpCode:     null;
  attributes:   null;
  data:         AgrupadorCorporacionLiquidadora;
  segment:      null;
}

export interface AgrupadorCorporacionLiquidadora {
  agrcorliq_id:     string;
  agrcorliq_nombre: string;
  agrcorliq_activo: boolean;
  agrcorliq_tipo: AgrupadorCorporacionLiquidadoraTipo;
}

export enum AgrupadorCorporacionLiquidadoraTipo {
  AJE_FILMS = "AJE_FILMS",
  ASESORIAS = "ASESORIAS"
}


export class AgrupadorCorporacionLiquidadoraSystem {
  private readonly base = '/agrupador-corporacion-liquidadora';

  constructor(private requestHandler: XhrRequestHandler) {}

  /**
   * Lista agrupadores
   */
  async list() {
    return this.requestHandler.get<AgrupadorCorporacionLiquidadoraResponse>(`${this.base}/list-activos`);
  }

  /**
   * Obtiene un agrupador por ID
   */
  async getById(id: number) {
    return this.requestHandler.get<AgrupadorCorporacionLiquidadoraResponseById>(`${this.base}/find-by-id/${id}`);
  }
}
